<script>
  import moment from "moment";
  import { onMount } from "svelte";
  import { navigate, Link } from "svelte-routing";
  import Button, { Label, Icon } from "@smui/button";
  import Select, { Option } from "@smui/select";
  import IconButton from "@smui/icon-button";
  import FormField from "@smui/form-field";
  import Switch from "@smui/switch";
  import Radio from "@smui/radio";
  import { exclude } from "@smui/common/exclude";
  import { apiPost } from "../httpCommon";
  import {
    Textfield,
    Textshow,
    RichEdit,
    ResourceShow,
    ResourceSelect
  } from "../components";

  export let id;
  export let title;
  export let data = null;
  export let topLevel = true;
  let errors = {};
  let resource = "users";
  let basePath = `/${resource}/${id}`;

  $: isCreate = id === "create";
  $: name =
    data && data.first_name + (data.last_name ? " " + data.last_name : "");

  $: {
    if (isCreate) {
      title = "Create User";
    } else if (name) {
      title = name;
    }
  }

  async function sendNotification(slug) {
    await apiPost(`/notifications/send-user-verification/${id}`, { slug });
  }
</script>

<ResourceShow {resource} bind:data bind:errors bind:id {topLevel}>
  <div slot="content" let:save>
    {#if data}
      <Textfield
        bind:value={data.first_name}
        error={errors.first_name}
        label="First Name" />
      <Textfield
        bind:value={data.last_name}
        error={errors.last_name}
        label="Last Name" />

      <span class="flex no-spread">
        <Select bind:value={data.role} label="User Type">
          <Option value="ADMIN" selected={true}>Admin</Option>
          <Option value="VENUE">Venue</Option>
          <Option value="VENDOR">Vendor</Option>
        </Select>
        {#if data.role === 'VENDOR'}
          &nbsp;
          <ResourceSelect
            bind:value={data.ref_id}
            resource="vendors"
            nameField="vendor_name"
            label="Vendor" />
        {:else if data.role === 'VENUE'}
          &nbsp;
          <ResourceSelect
            bind:value={data.ref_id}
            resource="venues"
            nameField="venue_name"
            label="Venue" />
        {/if}
      </span>

      <span class="flex no-spread">
        <Textfield
          type="email"
          class="long"
          bind:value={data.email}
          error={errors.email}
          label="Email" />
        <FormField>
          <Switch bind:checked={data.verified} on:change={save} />
          <span slot="label">Email verified</span>
        </FormField>
      </span>
      {#if !data.verified}
        <Button on:click={() => sendNotification('verify-email')}>
          <Label>Send Verification</Label>
        </Button>
        <br />
      {/if}
      <Textfield
        bind:value={data.telephone}
        error={errors.telephone}
        label="Telephone" />

      <span class="flex no-spread">
        <Textfield
          class="long"
          bind:value={data.username}
          error={errors.username}
          label="Username" />
        <FormField>
          <Switch bind:checked={data.login_allowed} on:change={save} />
          <span slot="label">Login allowed</span>
        </FormField>
      </span>
      {#if data.login_allowed}
        <Button on:click={() => sendNotification('password-reset')}>
          <Label>Send Password Reset</Label>
        </Button>
      {/if}
    {/if}
  </div>
</ResourceShow>
